import {useEffect} from 'react';
import {type Metric, onCLS, onFCP, onINP, onLCP, onTTFB} from 'web-vitals';

/**
 * Web Vitals monitoring component
 */
export function WebVitals() {
    useEffect(() => {
        const vitalsHandler = (_metric: Metric) => {
            // const span = appsignal.createSpan();
            // span.setNamespace('web_vitals');
            // span.setAction(`WebVitals: ${metric.name}`);
            // span.setTags({
            //     id: metric.id,
            //     rating: metric.rating,
            //     value: String(metric.value),
            //     navigationType: metric.navigationType,
            //     unit: metric.name === 'CLS' ? 'score' : 'ms',
            // });
            // appsignal.send(span);
        };

        // Core Web Vitals
        onCLS(vitalsHandler); // Cumulative Layout Shift
        onLCP(vitalsHandler); // Largest Contentful Paint
        onINP(vitalsHandler); // Interaction to Next Paint (replaces FID)

        // Additional metrics
        onFCP(vitalsHandler); // First Contentful Paint
        onTTFB(vitalsHandler); // Time to First Byte
    }, []);

    return null;
}
